import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース物件満了後の扱い */
enum AfterArticleExpirationProcessing {
  reLease = '1',
  return = '2',
  purchase = '3',
  discard = '4',
}

const nameConfig = {
  reLease: new Map([[Locale.ja, '再リース']]),
  return: new Map([[Locale.ja, '返却']]),
  purchase: new Map([[Locale.ja, '購入']]),
  discard: new Map([[Locale.ja, '廃棄']]),
};

const toEnum = rawValueToEnum(AfterArticleExpirationProcessing, AfterArticleExpirationProcessing.return);
const toDisplay = enumToName(AfterArticleExpirationProcessing, nameConfig);
const toDisplayWithPrefix = enumToName(AfterArticleExpirationProcessing, nameConfig, { prefix: true });

export const afterArticleExpirationProcessing = {
  enum: AfterArticleExpirationProcessing,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AfterArticleExpirationProcessing };
